import { Component, Input, Output, EventEmitter, VERSION } from '@angular/core';
import { ASSETS } from 'assets';
import { FontSizePicker, FontSize } from '../font-size-picker/font-size-picker';
import { LanguageDropdown } from '../language-dropdown/language-dropdown';
import { SHARED_IMPORTS } from '../shared-imports';

@Component({
  selector: 'app-nav-bar',
  imports: [FontSizePicker, LanguageDropdown, SHARED_IMPORTS],
  templateUrl: './nav-bar.html',
  styleUrls: ['./nav-bar.scss'],
})
export class NavBar {
  @Input() locale = 'en';
  @Output() readonly languageChange = new EventEmitter<string>();
  @Output() readonly fontSizeChange = new EventEmitter<FontSize>();

  protected readonly assets = ASSETS;
  protected readonly version = VERSION.full;
  protected readonly environment = ASSETS.appInfo.environment;

  handleLanguageChange(change: string): void {
    this.languageChange.emit(change);
  }

  handleFontSizeChange(size: FontSize): void {
    this.fontSizeChange.emit(size);
  }
}
